import React, {Component} from "react"
import {connect} from "react-redux"

import {TitleSection, SearchableList, ListItemUser, Button} from "~/components/"

import {User} from "~/utils/ShelfEntities"
import {withTranslation} from "react-i18next"

class TeamView extends Component {
  constructor(props) {
    super(props)

    this.state = {users: []}
  }

  update() {
    this.getData()
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    User.all()
      .then(users => {
        this.setState({users: users})
      })
      .catch(err => {
        console.log("Error loading user data: " + err)
      })
  }

  returnFilteredUsers(query) {
    query = query.toLowerCase()
    let new_users = []

    const currentUserIsAdmin = this.props.admin
    const currentUserIsSuperAdmin = this.props.superAdmin

    this.state.users.forEach(function(user, index) {
      let role = "BenutzerIn"
      let disableUserActions = false
      if (user.tenant_admin) {
        role = "Tenant AdministratorIn"
        if (!currentUserIsSuperAdmin && !currentUserIsAdmin) {
          disableUserActions = true
        }
      }
      if (user.admin) {
        role = "SABAG AdministratorIn"
        if (!currentUserIsSuperAdmin && !currentUserIsAdmin) {
          disableUserActions = true
        }
      }
      if (user.super_admin) {
        role = "Super AdministratorIn"
        disableUserActions = true
      }

      new_users.push({
        ...user,
        ...{
          role,
          disableUserActions
        }
      })
    })
    return new_users
  }

  render() {
    return (
      <div>
        <TitleSection>
          <h3>{this.props.t("users.title")}</h3>
          {(this.props.admin ||
            this.props.tenantAdmin ||
            this.props.superAdmin) && (
            <Button
              primary
              to="/users/new"
              icon="plus"
              label={this.props.t("users.new")}
            />
          )}
        </TitleSection>
        <SearchableList
          filteredItems={this.returnFilteredUsers.bind(this)}
          itemRenderer={ListItemUser}
          update={this.update.bind(this)}
        >
          <p>{this.props.t("users.empty")}</p>
        </SearchableList>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {admin, tenantAdmin, superAdmin} = user
  return {
    admin,
    tenantAdmin,
    superAdmin
  }
}

export default withTranslation()(connect(mapStateToProps)(TeamView))



// WEBPACK FOOTER //
// ./src/views/UsersView.js